import Modal from '@material-ui/core/Modal';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do Modal
 */
export default styled(Modal)`
  z-index: 2000 !important;

  section {
    nav {
      border-bottom: 1px solid #e5e5e5;
    }
    color: #5e6366;    
    width: ${({ sectionWidth }) => 
      (sectionWidth ? sectionWidth + 'px' : '787.75px')
    };    
    height: ${({ sectionHeight }) => 
      (sectionHeight ? sectionHeight + 'px' : '620.89px')
    };
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    background: #fff;

    @media (max-width: 768px) {
      width: 100vw;
      height: 100%;

      > button {
        display: none;
      }
    }

    > button {
      /* Close button */
      position: absolute;
      background: none;
      border: none;
      top: 8px;
      right: 5px;
    }

    .scrollable {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: hidden;
      align-self: stretch;
      flex: 1 0 auto;

      > div {
        flex: 0 0 100%;
        height: 100%;
        align-self: stretch;
      }
    }
  }
`;
